// Segmentos Service - SOLO LECTURA en tiempo real
// Lee TODA la colección ruleta_premios de Firestore
// La ruleta OBEDECE, NO modifica
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db } from './firebase';

// Colección de premios
const COLLECTION_PATH = 'ruleta_premios';

/**
 * Suscribirse a TODA la colección ruleta_premios en tiempo real
 * Devuelve todos los segmentos (segmento_01...segmento_16) con elegibilidad calculada
 * 
 * Campos esperados por segmento:
 * - activo, emergencia_apagado, probabilidad, prioridad
 * - no_repetir_hoy, no_consecutivo, limite_diario_global, limite_por_persona
 * - duracion_cantidad, duracion_unidad, para_que_sirve, condicion
 * 
 * @param {Function} callback - Función que recibe { segmentos, elegibles, totalSegmentos, totalElegibles, error }
 * @returns {Function} - Función para cancelar la suscripción
 */
export const listenSegmentos = (callback) => {
  const colRef = collection(db, COLLECTION_PATH);
  const q = query(colRef);
  
  const unsubscribe = onSnapshot(
    q,
    (querySnapshot) => {
      const segmentos = [];
      
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        
        // Calcular elegible: activo === true && emergencia_apagado !== true
        const activo = data.activo === true;
        const emergenciaApagado = data.emergencia_apagado === true;
        const elegible = activo && !emergenciaApagado;
        
        segmentos.push({
          id: doc.id,
          ...data,
          // Campos calculados
          elegible,
          _activo: activo,
          _emergenciaApagado: emergenciaApagado
        });
      });
      
      // Ordenar por ID (segmento_01, segmento_02, etc.)
      segmentos.sort((a, b) => a.id.localeCompare(b.id));
      
      // Array derivado: solo los elegibles
      const elegibles = segmentos.filter(s => s.elegible);
      
      console.log(`[Firebase] Colección actualizada: ${segmentos.length} segmentos, ${elegibles.length} elegibles`);
      console.log('[Firebase] Elegibles:', elegibles.map(s => s.id).join(', '));
      
      callback({
        segmentos,
        elegibles,
        totalSegmentos: segmentos.length,
        totalElegibles: elegibles.length,
        elegiblesIds: elegibles.map(s => s.id),
        error: null
      });
    },
    (error) => {
      console.error('[Firebase] Error leyendo colección:', error);
      callback({
        segmentos: [],
        elegibles: [],
        totalSegmentos: 0,
        totalElegibles: 0,
        elegiblesIds: [],
        error: error.message
      });
    }
  );
  
  return unsubscribe;
};

/**
 * Suscribirse a un segmento específico en tiempo real (mantener por compatibilidad)
 * @deprecated Usar listenSegmentos() para obtener toda la colección
 */
export const subscribeToSegment = (segmentId, callback) => {
  // Implementación legacy - redirigir a listenSegmentos filtrando
  return listenSegmentos((data) => {
    const segment = data.segmentos.find(s => s.id === segmentId);
    if (segment) {
      callback({
        exists: true,
        data: segment,
        elegible: segment.elegible,
        error: null,
        activo: segment._activo,
        emergenciaApagado: segment._emergenciaApagado
      });
    } else {
      callback({
        exists: false,
        data: null,
        elegible: false,
        error: `${segmentId} no existe`,
        activo: false,
        emergenciaApagado: false
      });
    }
  });
};
